import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
async function deserializeResponseBody(response, dataType, dataFormat) {
    return ObjectSerializer.deserialize(await response.body.json(), dataType, dataFormat);
}
async function deserializeErrorBodyOrFallback(response, dataType, dataFormat) {
    try {
        return await deserializeResponseBody(response, dataType, dataFormat);
    }
    catch {
        return await response.getBodyAsAny();
    }
}
export class ActionApprovalsApiRequestFactory extends BaseAPIRequestFactory {
    async cancelActionApprovalRequest(projectId, requestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "cancelActionApprovalRequest", "projectId");
        }
        if (requestId === null || requestId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "cancelActionApprovalRequest", "requestId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/my-requests/{requestId}/cancel'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'requestId' + '}', encodeURIComponent(String(requestId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createActionApprovalRequest(projectId, requestId, submitMyMPARequestRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRequest", "projectId");
        }
        if (requestId === null || requestId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRequest", "requestId");
        }
        if (submitMyMPARequestRequest === null || submitMyMPARequestRequest === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRequest", "submitMyMPARequestRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/my-requests/{requestId}/submit'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'requestId' + '}', encodeURIComponent(String(requestId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(submitMyMPARequestRequest, "SubmitMyMPARequestRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createActionApprovalRequestReview(projectId, requestId, createMPARequestReviewRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRequestReview", "projectId");
        }
        if (requestId === null || requestId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRequestReview", "requestId");
        }
        if (createMPARequestReviewRequest === null || createMPARequestReviewRequest === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRequestReview", "createMPARequestReviewRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/requests/{requestId}/reviews'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'requestId' + '}', encodeURIComponent(String(requestId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createMPARequestReviewRequest, "CreateMPARequestReviewRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createActionApprovalRule(projectId, createActionApprovalRuleRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRule", "projectId");
        }
        if (createActionApprovalRuleRequest === null || createActionApprovalRuleRequest === undefined) {
            throw new RequiredError("ActionApprovalsApi", "createActionApprovalRule", "createActionApprovalRuleRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createActionApprovalRuleRequest, "CreateActionApprovalRuleRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteActionApprovalRule(projectId, actionApprovalRuleId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "deleteActionApprovalRule", "projectId");
        }
        if (actionApprovalRuleId === null || actionApprovalRuleId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "deleteActionApprovalRule", "actionApprovalRuleId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules/{actionApprovalRuleId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'actionApprovalRuleId' + '}', encodeURIComponent(String(actionApprovalRuleId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getActionApprovalRequest(projectId, requestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getActionApprovalRequest", "projectId");
        }
        if (requestId === null || requestId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getActionApprovalRequest", "requestId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/requests/{requestId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'requestId' + '}', encodeURIComponent(String(requestId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getActionApprovalRule(projectId, actionApprovalRuleId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getActionApprovalRule", "projectId");
        }
        if (actionApprovalRuleId === null || actionApprovalRuleId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getActionApprovalRule", "actionApprovalRuleId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules/{actionApprovalRuleId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'actionApprovalRuleId' + '}', encodeURIComponent(String(actionApprovalRuleId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getActionApprovalSummary(projectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getActionApprovalSummary", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/summary'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getMyActionApprovalRequest(projectId, requestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getMyActionApprovalRequest", "projectId");
        }
        if (requestId === null || requestId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "getMyActionApprovalRequest", "requestId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/my-requests/{requestId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'requestId' + '}', encodeURIComponent(String(requestId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listActionApprovalOperations(_options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        const localVarPath = '/v1/action-approvals/operations';
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listActionApprovalRequests(projectId, pageToken, pageSize, listMPARequestsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "listActionApprovalRequests", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/requests/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listMPARequestsRequest, "ListMPARequestsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listActionApprovalRules(projectId, pageToken, pageSize, listActionApprovalRulesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "listActionApprovalRules", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listActionApprovalRulesRequest, "ListActionApprovalRulesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listActionApprovalRulesDeprecated(projectId, operation, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "listActionApprovalRulesDeprecated", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (operation !== undefined) {
            requestContext.setQueryParam("operation", ObjectSerializer.serialize(operation, "ActionApprovalOperationType", ""));
        }
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listMyActionApprovalRequests(projectId, pageToken, pageSize, listMyMPARequestsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "listMyActionApprovalRequests", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/my-requests/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listMyMPARequestsRequest, "ListMyMPARequestsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateActionApprovalRule(projectId, actionApprovalRuleId, updateActionApprovalRuleRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "updateActionApprovalRule", "projectId");
        }
        if (actionApprovalRuleId === null || actionApprovalRuleId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "updateActionApprovalRule", "actionApprovalRuleId");
        }
        if (updateActionApprovalRuleRequest === null || updateActionApprovalRuleRequest === undefined) {
            throw new RequiredError("ActionApprovalsApi", "updateActionApprovalRule", "updateActionApprovalRuleRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules/{actionApprovalRuleId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'actionApprovalRuleId' + '}', encodeURIComponent(String(actionApprovalRuleId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateActionApprovalRuleRequest, "UpdateActionApprovalRuleRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateActionApprovalRuleDeprecated(projectId, actionApprovalRuleId, updateActionApprovalRuleRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "updateActionApprovalRuleDeprecated", "projectId");
        }
        if (actionApprovalRuleId === null || actionApprovalRuleId === undefined) {
            throw new RequiredError("ActionApprovalsApi", "updateActionApprovalRuleDeprecated", "actionApprovalRuleId");
        }
        if (updateActionApprovalRuleRequest === null || updateActionApprovalRuleRequest === undefined) {
            throw new RequiredError("ActionApprovalsApi", "updateActionApprovalRuleDeprecated", "updateActionApprovalRuleRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/action-approvals/rules/{actionApprovalRuleId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'actionApprovalRuleId' + '}', encodeURIComponent(String(actionApprovalRuleId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateActionApprovalRuleRequest, "UpdateActionApprovalRuleRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class ActionApprovalsApiResponseProcessor {
    async cancelActionApprovalRequestWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "CancelMyMPARequestResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Unauthorized because the action request was created by another caller.", body, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action request wasn\&#39;t found.", body, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action request can\&#39;t be canceled in its current status.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createActionApprovalRequestWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "SubmitMyMPARequestResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Unauthorized because the action request was created by another caller.", body, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action request wasn\&#39;t found.", body, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action request can\&#39;t be submitted or discarded in its current status.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createActionApprovalRequestReviewWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "CreateMPARequestReviewResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Not authorized (requester cannot decide on own request)", body, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "action approval request not found", body, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Request is not in PENDING_APPROVAL status", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createActionApprovalRuleWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "CreateActionApprovalRuleResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Invalid action approval rule configuration.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteActionApprovalRuleWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action approval rule wasn\&#39;t found.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getActionApprovalRequestWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetMPARequestResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "action approval request not found", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getActionApprovalRuleWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetActionApprovalRuleResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action approval rule wasn\&#39;t found.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getActionApprovalSummaryWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetActionApprovalSummaryResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getMyActionApprovalRequestWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetMPARequestResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Unauthorized because the action request was created by another caller.", body, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Action request wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listActionApprovalOperationsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListMPAOperationsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listActionApprovalRequestsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListMPARequestsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listActionApprovalRulesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListActionApprovalRulesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Invalid pagination parameters or operation filter.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listActionApprovalRulesDeprecatedWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListActionApprovalRulesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Invalid pagination parameters or operation filter.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listMyActionApprovalRequestsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListMyMPARequestsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateActionApprovalRuleWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "UpdateActionApprovalRuleResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Invalid action approval rule configuration.", body, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action approval rule wasn\&#39;t found.", body, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "The updated action approval rule conflicts with another rule.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateActionApprovalRuleDeprecatedWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "UpdateActionApprovalRuleResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Invalid action approval rule configuration.", body, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Action approval rule wasn\&#39;t found.", body, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "The updated action approval rule conflicts with another rule.", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
